import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

import Error from "@/components/Error.vue";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import {$t} from "@/utilities/i18n/config";
import {onMounted} from "vue";
import AuthService from "@/utilities/services/AuthService";
import router from "@/router";
import {notify} from "@kyvg/vue3-notification";
import jwt_decode from "jwt-decode";
import {useGlobalStore} from "@/stores/GlobalStore";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {GeneralOldResponse} from "@/models/api/old/responses";
import UserService from "@/utilities/services/entities/UserService";



export default /*#__PURE__*/_defineComponent({
  __name: 'OAuthCallback',
  setup(__props) {

const globalStore = useGlobalStore();
const userService = new UserService();

onMounted(async ()=> {
  //TODO dont get default instance since config can point to custom auth
  const oAuthService = AuthService.getDefaultInstance();

  const userManager = oAuthService.userManager;
  try {
    const oAuthUser = await userManager.signinRedirectCallback();

    const decoded = jwt_decode(oAuthUser.access_token) as {preferred_username:string};
    const resp = await userService.getByMail(decoded.preferred_username, ErrorLocationType.login);
    if(!resp) return;
    globalStore.user = resp;

    const routeToPush = oAuthUser.state?.redirectAfterLogin || "/dashboard";
    await router.push(routeToPush);
    (useGlobalStore()).redirectAfterLogin = null

    notify({
      title: "Erfolg",
      text: $t('general.notifySuccessfulLogin'),
      duration: 5000,
      type: "success"
    });
  }
  catch (e){
    console.error("Login failed:", e)
    const generalResponse = new GeneralOldResponse(false, "entra", 401);
    await ErrorHandler.handleOldError(generalResponse, ErrorLocationType.login)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(" Waiting "),
    (_ctx.error)
      ? (_openBlock(), _createBlock(Error, {
          key: 0,
          errorLoc: _unref(ErrorLocationType).login
        }, null, 8, ["errorLoc"]))
      : _createCommentVNode("", true)
  ]))
}
}

})